<script setup lang="ts">

const storeU = useUtilisateurStore()
const showYearPicker = ref(false)
const currentYear = new Date().getFullYear()
const years = ref(Array.from({ length: currentYear - 2024 + 2 }, (_, i) => 2024 + i))

function confirm(year: number) {
  storeU.sélectionnerAnnée(year)
  showYearPicker.value = false
}
</script>

<template>
  <v-btn color="primary" class="me-2 ml-2" variant="outlined" rounded="lg" min-width="100" @click="showYearPicker = true">
    <span class="text-h5">{{ storeU.annéeSélectionnée }}</span>
  </v-btn>

  <v-dialog v-model="showYearPicker" max-width="320px" :fullscreen="$vuetify.display.xs">
    <v-card rounded="xl" class="overflow-hidden pa-0">

      <div class="year-picker-header">
        <div class="text-overline year-picker-header__label">Année sélectionnée</div>
        <div class="text-h4 font-weight-bold year-picker-header__year">
          {{ storeU.annéeSélectionnée }}
        </div>
        <v-btn
          density="comfortable"
          icon="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
          variant="text"
          color="white"
          class="year-picker-header__close"
          @click="showYearPicker = false"
        />
      </div>

      <v-card-text class="px-4 pt-5 pb-2">
        <v-row dense>
          <v-col v-for="year in years" :key="year" cols="6">
            <v-btn
              :color="year === storeU.annéeSélectionnée ? 'primary' : undefined"
              :variant="year === storeU.annéeSélectionnée ? 'flat' : 'tonal'"
              :elevation="year === storeU.annéeSélectionnée ? 2 : 0"
              rounded="lg"
              block
              size="large"
              class="year-btn"
              @click="confirm(year)"
            >
              {{ year }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="px-4 pb-4 pt-1">
        <v-spacer />
        <v-btn variant="text" rounded="lg" @click="showYearPicker = false">Annuler</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<style scoped>
.year-picker-header {
  position: relative;
  background: rgb(var(--v-theme-primary));
  padding: 20px 24px 18px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.year-picker-header__label {
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 0.1em;
  font-size: 0.7rem;
}
.year-picker-header__year {
  color: #fff;
}
.year-picker-header__close {
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0.8;
}
.year-picker-header__close:hover {
  opacity: 1;
}
.year-btn {
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.02em;
}
</style>
